import Collection from './generic/collection'

export const instance = '[data-table-filters-form]'

export default class TableFilters {
  instance = instance

  els = {
    tableForSort: '[data-filter-table]',
    filterDataSelector: '[data-filter-params]',
    filterData: 'filterParams',
  }

  constructor (instance) {
    this.instance = instance
    this.bindEvents()
  }

  /**
   * @param filterName {String}
   * @param filterValue {String}
   * @param node {HTMLElement}
   */

  setFilterParams ({ filterName, filterValue }, node) {
    let newData = {}

    newData = {
      filterName: filterName,
      filterValue: filterValue,
    }

    newData = JSON.stringify(newData)
    node.dataset[this.els.filterData] = newData
  }

  bindEvents () {
    $(document).on('setFilter', (event, dataInput, container) => this.setFilterParams(dataInput, container))
  }

}

export class TableFiltersCollection extends Collection {
  constructor () {
    super(instance, TableFilters)

    this.init()
    this.bindEvents()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new TableFilters(el)
    })
  }

  bindEvents () {}
}
